import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import {Box, BoxButton, MainHeading} from '../../StyledComponents';
import BubbleChart from './BubbleChart'

const BubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const BubbleChartDiv = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /*min-height: 160px;
  min-width: 300px;*/
`


class KeyFocusImprovements extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { data, user } = this.props;
    if (!data) {
      return <Box/>;
    };
    const property = data.sentimentData && data.sentimentData.highestPotentialVar && data.sentimentData.highestPotentialVar.id;
    const sentimentSettings = this.props.user.client && this.props.user.client.sentimentSettings;
    let paramSentiment = _.filter(sentimentSettings, function(row, i) {
      return row[0].value === property
    })

    let keywords = [];

    // Make array into object
    let hints = [];
    _.each(paramSentiment, function(row, i) {
      let hint = {};
      _.each(row, function(col,i) {
        hint[col.type] = col.value
      });
      hints.push(hint);
    })

    //
    let recommendations = {};
    _.each(hints, function(hint, i) {
      let keywordHints = recommendations[hint.keyword] && recommendations[hint.keyword].hints || [];
      keywordHints.push({title: hint.hint, weight: hint.weight});
      recommendations[hint.keyword] = recommendations[hint.keyword] || {};
      recommendations[hint.keyword].hints = keywordHints;
    })

    // Back to array
    let recommendationObjects = [];

    Object.keys(recommendations).map(function(objectKey, index) {
      var recommendation = recommendations[objectKey];
      recommendationObjects.push({
        title: objectKey,
        keywords: recommendation.hints
      })
    });

    let bubbleData = [];

    _.each(recommendationObjects, function(obj, i) {
      let bubble = [];

      bubble.push({
        _id: obj.title,
        value: 350,
        selected: true
      })

      _.each(obj.keywords, function(keyword, i) {
        bubble.push({
          _id: keyword.title,
          value: keyword.weight, //100
          selected: true
        })
      })

      bubbleData.push(bubble);
    });

    return (
      <Box>
        <MainHeading>Key Focus Improvements</MainHeading>
        <BubbleContainer>
          {_.map(recommendationObjects, (rec, i) => {
              return (
                <BubbleChartDiv key={i}><BubbleChart data={bubbleData && bubbleData[i]} colorIndex={i}/></BubbleChartDiv>
              )
            }
          )}
        </BubbleContainer>
      </Box>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default withRouter(connect(mapStateToProps, {})(KeyFocusImprovements));



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/KeyFocusImprovements.js